/**
 * Created by SJ on 12/6/16.
 */
import {
  SHOW_TOAST,
  SET_TOAST_SHOW,
  SET_TOAST_HIDE,
  SET_LOADING,
  SET_DESTROY,
  SET_REGION,
  SET_LANG
} from '../types'

const globalModule = {
  state: {
    tips: {
      msg: '',
      show: false
    },
    loading: {
      percentage: 0
    },
    destroy: {
      flag: 0,
      name: ''
    },
    region: '',
    lang: '',
    code: ''
  },
  mutations: {
    [SET_TOAST_SHOW] (state, msg) {
      state.tips.msg = msg
      state.tips.show = true
    },
    [SET_TOAST_HIDE] (state, msg) {
      state.tips.msg = msg
      state.tips.show = false
    },
    [SET_LOADING] (state, percentage) {
      state.loading.percentage = percentage
      if (percentage === 100) {
        setTimeout(function () {
          state.loading.percentage = 0
        }, 0)
      }
    },
    [SET_DESTROY] (state, name) {
      state.destroy.flag = 1
      state.destroy.name = name
      console.log(state.destroy)
    },
    [SET_REGION] (state, name) {
      state.region = name
    },
    [SET_LANG] (state, name) {
      state.lang = name
    }
  },
  actions: {
    [SHOW_TOAST] ({commit}, msg) {
      commit(SET_TOAST_SHOW, msg)
      setTimeout(function () {
        commit(SET_TOAST_HIDE)
      }, 3000)
    }
  },
  getters: {
  }
}
export default globalModule



// WEBPACK FOOTER //
// ./src/store/modules/global.js